import React from 'react';
import { GiCow } from 'react-icons/gi';
import '../styles/maveshi-brand-logo.css';

const SIZE_MAP = {
  xs: { box: 28, icon: 16, radius: 8 },
  sm: { box: 40, icon: 24, radius: 12 },
  md: { box: 52, icon: 32, radius: 14 },
  lg: { box: 80, icon: 48, radius: 24 },
  xl: { box: 96, icon: 56, radius: 28 },
};

/**
 * Shared Maveshi cow brand mark — matches the app loading screen.
 * @param {'icon'|'lockup'} variant
 * @param {'xs'|'sm'|'md'|'lg'|'xl'} size
 * @param {boolean} pulse — subtle pulse ring (loading screen style)
 */
export default function MaveshiBrandLogo({
  variant = 'icon',
  size = 'md',
  pulse = false,
  wordmark = 'Maveshiwala',
  className = '',
}) {
  const dims = SIZE_MAP[size] || SIZE_MAP.md;

  const iconMark = (
    <div
      className={`maveshi-brand-icon-wrap ${pulse ? 'maveshi-brand-icon-wrap--pulse' : ''}`}
      style={{
        width: dims.box,
        height: dims.box,
        borderRadius: dims.radius,
      }}
    >
      <GiCow style={{ fontSize: dims.icon, color: '#ffffff' }} aria-hidden="true" />
    </div>
  );

  if (variant === 'lockup') {
    return (
      <div className={`maveshi-brand-lockup ${className}`.trim()}>
        {iconMark}
        <span className="maveshi-brand-wordmark">{wordmark}</span>
      </div>
    );
  }

  return (
    <div className={`maveshi-brand-icon ${className}`.trim()}>
      {iconMark}
    </div>
  );
}
